var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"un-login"},[_c('div',{staticClass:"login-btn",on:{"click":function($event){$event.stopPropagation();return _vm.handleClickLogin($event)}}},[_vm._v("登录/注册")]),_c('p',{staticClass:"desc"},[_vm._v("登录名企校招小程序，查看更多校招职位")])])}
var staticRenderFns = []

export { render, staticRenderFns }